(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melibelt-catalog"]) return;
  try {
    
  // Filtro por categoría — mismo comportamiento del mockup aprobado, ahora sobre datos reales
  (function(){
    var cards = Array.prototype.slice.call(document.querySelectorAll('.mc-p-card'));
    var catItems = Array.prototype.slice.call(document.querySelectorAll('.mc-cat-item'));
    var resultsCount = document.getElementById('mcResultsCount');
    var noResults = document.getElementById('mcNoResults');

    function applyFilter(filter){
      var visible = 0;
      cards.forEach(function(card){
        var cats = (card.dataset.cats || '').split(',');
        var show = filter === 'all' || cats.indexOf(filter) !== -1;
        card.classList.toggle('hidden', !show);
        if(show) visible++;
      });
      resultsCount.textContent = visible + (visible === 1 ? ' resultado' : ' resultados');
      noResults.classList.toggle('show', visible === 0);
      catItems.forEach(function(c){ c.classList.toggle('active', c.dataset.filter === filter); });
    }

    catItems.forEach(function(c){
      c.addEventListener('click', function(){ applyFilter(c.dataset.filter); });
    });

    // Deep-link desde Inicio: catalogo?cat=postparto (u otro filtro válido)
    var params = new URLSearchParams(window.location.search);
    var wanted = params.get('cat');
    var validFilters = catItems.map(function(c){ return c.dataset.filter; });
    if(wanted && validFilters.indexOf(wanted) !== -1){
      applyFilter(wanted);
      var section = document.querySelector('.mc-categories');
      if(section){ setTimeout(function(){ section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50); }
    }
  })();

  // Ordenar — reordena las tarjetas reales en el DOM
  (function(){
    var grid = document.getElementById('mcProductGrid');
    if(!grid) return;
    var originalOrder = Array.prototype.slice.call(grid.children);
    var sortBtn = document.getElementById('mcSortBtn');
    var sortMenu = document.getElementById('mcSortMenu');
    var sortLabel = document.getElementById('mcSortLabel');
    var sortOptions = Array.prototype.slice.call(document.querySelectorAll('.mc-sort-option'));

    sortBtn.addEventListener('click', function(e){
      e.stopPropagation();
      sortMenu.classList.toggle('open');
      sortBtn.classList.toggle('open');
    });
    document.addEventListener('click', function(){
      sortMenu.classList.remove('open');
      sortBtn.classList.remove('open');
    });

    sortOptions.forEach(function(opt){
      opt.addEventListener('click', function(){
        var mode = opt.dataset.sort;
        sortLabel.textContent = opt.textContent;
        sortOptions.forEach(function(o){ o.classList.toggle('active', o === opt); });

        var sorted;
        if(mode === 'relevancia'){
          sorted = originalOrder;
        } else if(mode === 'precio-asc'){
          sorted = originalOrder.slice().sort(function(a,b){ return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); });
        } else if(mode === 'precio-desc'){
          sorted = originalOrder.slice().sort(function(a,b){ return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); });
        } else if(mode === 'nombre-az'){
          sorted = originalOrder.slice().sort(function(a,b){ return a.querySelector('h3').textContent.localeCompare(b.querySelector('h3').textContent); });
        }
        sorted.forEach(function(card){ grid.appendChild(card); });

        sortMenu.classList.remove('open');
        sortBtn.classList.remove('open');
      });
    });
  })();

  // Filas de etiquetas — difuminado en el borde cuando hay más para desplazar
  (function(){
    var rows = Array.prototype.slice.call(document.querySelectorAll('.mc-p-tags'));
    function markOverflow(){
      rows.forEach(function(row){
        row.classList.toggle('scrollable', row.scrollWidth > row.clientWidth + 2);
      });
    }
    markOverflow();
    window.addEventListener('resize', markOverflow);
    window.addEventListener('load', markOverflow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melibelt-header"]) return;
  try {
    
  (function(){
    var btn = document.getElementById('melibeltMenuToggle');
    var menu = document.getElementById('melibeltMobileMenu');
    if(!btn || !menu) return;
    btn.addEventListener('click', function(){
      var isOpen = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen);
      btn.classList.toggle('open', isOpen);
    });
    menu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        menu.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('open');
      });
    });
  })();

  (function(){
    var bar = document.getElementById('melibeltAnnounceBar');
    if(!bar) return;
    var textEl = bar.querySelector('span');
    var messages = ['Todos nuestros pedidos son hechos con amor', 'Envío gratis a toda Guatemala'];
    var i = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduceMotion || messages.length < 2) return;
    setInterval(function(){
      i = (i + 1) % messages.length;
      textEl.style.opacity = 0;
      setTimeout(function(){
        textEl.textContent = messages[i];
        textEl.style.opacity = 1;
      }, 300);
    }, 4500);
  })();

  // Header fijo controlado por JS (ver nota en el stylesheet de arriba): position:sticky no se
  // veia fijo en la vista previa real porque el tema base Horizon usa .page-wrapper (no
  // window/body) como el contenedor real de scroll en escritorio. position:fixed, en cambio,
  // siempre se posiciona respecto al viewport sin importar que elemento haga scroll, asi que
  // este listener escucha tanto .page-wrapper como window (el que realmente dispare el evento
  // segun el ancho de pantalla) y agrega/quita la clase .mb-pinned a mano.
  (function(){
    var header = document.getElementById('melibeltHeader');
    var spacer = document.getElementById('melibeltHeaderSpacer');
    if(!header) return;
    var scrollParent = document.querySelector('.page-wrapper');
    var pinned = false;
    var threshold = 24;

    function getScrollY(){
      var fromParent = scrollParent ? scrollParent.scrollTop : 0;
      var fromWindow = window.scrollY || window.pageYOffset || 0;
      return Math.max(fromParent, fromWindow);
    }

    function update(){
      var shouldPin = getScrollY() > threshold;
      if(shouldPin && !pinned){
        if(spacer){ spacer.style.height = header.offsetHeight + 'px'; }
        header.classList.add('mb-pinned');
        pinned = true;
      } else if(!shouldPin && pinned){
        header.classList.remove('mb-pinned');
        if(spacer){ spacer.style.height = '0px'; }
        pinned = false;
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    if(scrollParent){ scrollParent.addEventListener('scroll', update, { passive: true }); }
    window.addEventListener('resize', function(){
      if(pinned && spacer){ spacer.style.height = header.offsetHeight + 'px'; }
    });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melibelt-index"]) return;
  try {
    
  // El observer de .reveal (IntersectionObserver que agrega la clase "in") vive ahora en
  // snippets/melibelt-styles.liquid como <script> plano, porque este bloque de javascript de
  // seccion solo se ejecuta cuando ESTA seccion se renderiza, y .reveal se usa en varias
  // paginas (Inicio, Asesoria). Ver leccion tecnica #19 en el documento de contexto.

  // Hero carousel — autoplay + dots
  (function(){
    var root = document.getElementById('mbHeroCarousel');
    if(!root) return;
    var slides = root.querySelectorAll('.mb-carousel-slide');
    var dots = root.querySelectorAll('.mb-carousel-dots button');
    var idx = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i){
      slides[idx].classList.remove('active');
      dots[idx].classList.remove('active');
      idx = i;
      slides[idx].classList.add('active');
      dots[idx].classList.add('active');
    }
    dots.forEach(function(btn){
      btn.addEventListener('click', function(){ go(parseInt(btn.dataset.i)); });
    });
    if(!reduceMotion){
      setInterval(function(){ go((idx+1) % slides.length); }, 5000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melibelt-product"]) return;
  try {
    
  // Galería: click en una miniatura cambia la foto principal (sin librerías)
  (function(){
    var main = document.getElementById('pdMainImg');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pd-thumb'));
    if(!main || !thumbs.length) return;
    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){
        main.src = btn.dataset.full;
        main.alt = btn.dataset.alt;
        thumbs.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
